module.exports = __webpack_public_path__ + "img/where-they-won_sm.jpg";